export default "__VITE_ASSET__CfL65HqT__"